import _toConsumableArray from "/root/workspace/OKEY-front_sY8I/node_modules/_@babel_runtime@7.29.2@@babel/runtime/helpers/esm/toConsumableArray.js";
import _createForOfIteratorHelper from "/root/workspace/OKEY-front_sY8I/node_modules/_@babel_runtime@7.29.2@@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import store from "@/store";
var SERVERAPI = process.env.VUE_APP_OKEY_SERVER_API;
export default {
  name: "navi-search-dialog",
  components: {},
  data: function data() {
    return {
      visible: false,
      input: "",
      filteredList: [],
      recentList: []
    };
  },
  computed: {},
  created: function created() {
    console.log("hehehe");
    console.log(this.$store.state.menu.addRoutes);
    var recent = localStorage.getItem("recentMenu");
    this.recentList = recent ? JSON.parse(recent) : [];
  },
  methods: {
    init: function init() {
      this.visible = true;
    },
    filterList: function filterList() {
      var keyword = this.input.trim().toLowerCase();
      if (!keyword) {
        this.filteredList = [];
        return;
      }
      function flattenRoutes(routes, keyword) {
        var result = [];
        var _iterator = _createForOfIteratorHelper(routes),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var route = _step.value;
            if (route.name && route.name.toLowerCase().includes(keyword) && route.children.length == 0) {
              result.push(route);
            }
            if (route.children && route.children.length > 0) {
              result = result.concat(flattenRoutes(route.children, keyword));
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return result;
      }
      this.filteredList = flattenRoutes(this.$store.state.menu.addRoutes, keyword);
      console.log("sss");
      console.log(this.filteredList);
    },
    findTopParentId: function findTopParentId(routes, targetId) {
      var _iterator2 = _createForOfIteratorHelper(routes),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var route = _step2.value;
          if (route.id === targetId) {
            return route;
          }
          if (route.children && route.children.length > 0) {
            var found = this.findInChildren(route.children, targetId);
            if (found) {
              return route;
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return null;
    },
    findInChildren: function findInChildren(children, targetId) {
      var _iterator3 = _createForOfIteratorHelper(children),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var child = _step3.value;
          if (child.id === targetId) {
            return true;
          }
          if (child.children && child.children.length > 0) {
            if (this.findInChildren(child.children, targetId)) {
              return true;
            }
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return false;
    },
    goDetailAct: function goDetailAct(item) {
      var _this = this;
      this.visible = false;
      this.recentList = [item].concat(_toConsumableArray(this.recentList.filter(function (i) {
        return i.id !== item.id;
      }))).slice(0, 20);
      localStorage.setItem("recentMenu", JSON.stringify(this.recentList));
      var route = this.findTopParentId(this.$store.state.menu.addRoutes, item.id);
      var index = this.$store.state.menu.addRoutes.findIndex(function (r) {
        return r === route;
      });
      console.log("001", route);
      console.log("002", index);
      if (route.status == 0) {
        this.$message.warning('当前菜单已停用');
        return;
      }
      this.$store.dispatch('menu/initSubRouters', route);
      this.$store.dispatch('menu/setActiveId', route.id);
      setTimeout(function () {
        _this.$router.push(item.path);
      }, 250);
    },
    deleteAct: function deleteAct(citem) {
      this.recentList = this.recentList.filter(function (item) {
        return item.id !== citem.id;
      });
      localStorage.setItem("recentMenu", JSON.stringify(this.recentList));
    }
  }
};